import { yup } from '@framework/validation/initYup.ts';
import { Decimal } from 'decimal.js-light';
import { isDate } from 'lodash';
import { type IReferencePlainValue } from '../references/IReference.ts';

export const ReferencePlainValueSchema = yup
  .mixed<Exclude<IReferencePlainValue, null>>()
  .test({
    name: 'reference-plain',
    message: 'Il valore non è valido',
    test(value) {
      if (value == null) return true;
      return (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        isDate(value) || // TODO Check x moment
        Array.isArray(value) ||
        value instanceof Decimal
      );
    },
  });
